import scrollMonitor from 'scrollmonitor';
import toArray from './../../scripts/to-array';
import classnameToggle from './../../scripts/classname-toggle';

toArray(document.querySelectorAll('[data-component="careers-department"]')).forEach((component) => {
  const wrapper = document.querySelector('[data-component="careers-positions"]');
  const gallery = component.querySelector('[careers-department-gallery]');
  const categoryCheckboxes = component.querySelectorAll('[data-careers-department-category-checkbox]');

  const watcher = scrollMonitor.create(wrapper, { top: -140 });

  function visibilityChecker() {
    classnameToggle(gallery, 'is-sticky', watcher.isFullyInViewport);
    classnameToggle(gallery, 'is-top-positioned', watcher.isBelowViewport);
  }

  watcher.stateChange(visibilityChecker);
  visibilityChecker();

  function toggleDepartment(active, checkbox, categoryContent, categoryItem) {
    if (active) {
      categoryItem.classList.add('is-open');
      categoryContent.style.maxHeight = `${categoryContent.scrollHeight}px`; // eslint-disable-line no-param-reassign
    } else {
      checkbox.checked = false; // eslint-disable-line no-param-reassign
      categoryItem.classList.remove('is-open');
      categoryContent.style.maxHeight = 0; // eslint-disable-line no-param-reassign
    }
  }

  if (categoryCheckboxes) {
    toArray(categoryCheckboxes).forEach((currentCheckbox) => {
      if (currentCheckbox.checked) {
        toggleDepartment(true, currentCheckbox, currentCheckbox.nextElementSibling.nextElementSibling, currentCheckbox.parentElement); // eslint-disable-line max-len
      }

      currentCheckbox.addEventListener('change', () => {
        toArray(categoryCheckboxes).forEach((checkbox) => {
          const categoryContent = checkbox.nextElementSibling.nextElementSibling;
          const categoryItem = checkbox.parentElement;

          if (checkbox === currentCheckbox && checkbox.checked) {
            toggleDepartment(true, checkbox, categoryContent, categoryItem);
          } else {
            toggleDepartment(false, checkbox, categoryContent, categoryItem);
          }

          scrollMonitor.update();
          watcher.triggerCallbacks();
        });
      });
    });
  }
});

